import { useEffect, useState } from "react";
import ProgressLoader from "@/components/progress-loader";

const BASE = import.meta.env.BASE_URL;

export default function MentorInterests() {
  const [rows, setRows] = useState<any[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    const tok = localStorage.getItem("mentor_token") || "";
    fetch(`${BASE}api/mentor-portal/my-interests`, { headers: { "x-mentor-token": tok } })
      .then(r => r.ok ? r.json() : r.json().then(d => Promise.reject(d.error || `${r.status}`)))
      .then(d => setRows(d.interests))
      .catch(e => setErr(String(e)));
  }, []);

  if (err) return <div className="max-w-3xl mx-auto px-6 py-10 text-sm text-red-400">{err}</div>;
  if (!rows) return <div className="max-w-3xl mx-auto px-6 py-10"><ProgressLoader active={true} title="Loading" stages={["Loading your pending interests", "Cross-referencing missions"]} /></div>;

  return (
    <div className="max-w-4xl mx-auto px-6 py-8">
      <h1 className="text-2xl font-bold mb-6">My interests</h1>
      {rows.length === 0 ? (
        <div className="bg-[var(--mentor-card)] border border-[var(--mentor-border)] rounded-lg p-8 text-center text-sm text-[var(--mentor-fg-muted)]">
          You haven't expressed interest in any missions yet.
        </div>
      ) : (
        <div className="bg-[var(--mentor-card)] border border-[var(--mentor-border)] rounded-lg divide-y divide-[var(--mentor-border)]">
          {rows.map((r) => (
            <div key={r.id} className="px-4 py-3" data-testid={`interest-row-${r.id}`}>
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="text-sm font-medium">{r.missionTitle || "Mission deleted"}</div>
                  <div className="text-xs text-[var(--mentor-fg-muted)]">{r.companyName} · expressed {fmt(r.expressedAt)}</div>
                  {r.declineReason && <div className="text-xs text-red-300 mt-1">Founder note: {r.declineReason}</div>}
                </div>
                <StatusBadge status={r.status} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function StatusBadge({ status }: { status: string }) {
  const map: Record<string, { label: string; cls: string }> = {
    pending_founder: { label: "Awaiting founder", cls: "bg-amber-500/15 text-amber-300" },
    reconfirmation_required: { label: "Re-confirmation needed", cls: "bg-blue-500/15 text-blue-300" },
    intro_scheduled: { label: "Intro scheduled", cls: "bg-emerald-500/15 text-emerald-300" },
    declined: { label: "Declined", cls: "bg-red-500/15 text-red-300" },
    auto_rescinded: { label: "Auto-rescinded (SLA)", cls: "bg-zinc-500/15 text-zinc-300" },
  };
  const m = map[status] || { label: status, cls: "bg-zinc-500/15 text-zinc-300" };
  return <span className={`text-[10px] font-medium px-2 py-0.5 rounded ${m.cls}`}>{m.label}</span>;
}

function fmt(d: string | null) { if (!d) return ""; return new Date(d).toLocaleDateString(); }
